import api from "../common/api";

const getHitoric = () => api.get("/payment-historic");

const update = (id) => api.put(`/payment-historic/${id}`);

const paymentHistoricService = { getHitoric, update };

export default paymentHistoricService;
